module.exports = __webpack_public_path__ + "static/media/amrit_ayalur.76133f99.jpeg";